var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5770_13867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 24C4.724 24 4.5 23.776 4.5 23.5V17.926C4.5 17.65 4.724 17.426 5 17.426C9.657 17.426 17.909 15.865 18.584 14.857C18.707 14.674 18.932 14.592 19.145 14.657C19.355 14.721 19.499 14.916 19.499 15.136V20.626C19.499 20.726 19.469 20.822 19.414 20.904C18.213 22.692 8.679 24 5 24ZM6 19V22.5C10.642 22.4 16.92 21.026 18 20V17C15.369 18.296 9.355 18.908 6 19ZM5 9.365C4.724 9.365 4.5 9.141 4.5 8.865V3.291C4.5 3.015 4.724 2.791 5 2.791C9.657 2.791 17.909 1.23 18.584 0.221997C18.707 0.0389971 18.932 -0.0430029 19.145 0.021997C19.356 0.0859971 19.5 0.279997 19.5 0.499997V5.99C19.5 6.09 19.47 6.186 19.415 6.268C18.213 8.058 8.679 9.365 5 9.365ZM6.5 4.50004V7.50004C11.142 7.40004 16.92 6.52604 18 5.50004V2.50004C15.369 3.79504 9.855 4.40804 6.5 4.50004Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.684C4.724 16.684 4.5 16.46 4.5 16.184V10.609C4.5 10.333 4.724 10.109 5 10.109C9.657 10.109 17.909 8.548 18.584 7.54C18.707 7.357 18.932 7.274 19.145 7.34C19.355 7.404 19.499 7.599 19.499 7.819V13.31C19.499 13.41 19.469 13.506 19.414 13.588C18.213 15.376 8.679 16.684 5 16.684ZM6 11.5V15C10.642 14.9 17.2172 13.526 18.2972 12.5V9.50001C15.6662 10.795 9.355 11.408 6 11.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5770_13867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScala);
export default __webpack_public_path__ + "static/media/scala.0d185dba.svg";
export { ForwardRef as ReactComponent };